export const BUTTON_ACITON_TYPES = ['url', 'web_url'];
export const MAX_TITLE_LENGTH = 50;
export const MAX_BODY_LENGTH = 60;
